/**
 * This module provides functions in relation to calling API routes on the backend server and processing the incoming
 * responses. The functions in this module refer to the API endpoint ApiEndPoints.FEE.
 * @module
 */

import {ApiEndPoints, HttpMethods} from "../base/Settings";
import type {FetchRequest, FeeInput, Fee, UUID, WaterfallItemInput} from "../base/ui_general/GeneralInterfaces";


/**
 * Creates a FetchRequest object for creating a new fee, including both the fee and its associated waterfall item.
 * @param feeInput An object of type FeeInput containing the input data for creating the fee.
 * @param waterfallItemInput An object of type WaterfallItemInput containing the input data for the associated waterfall item.
 * @returns A FetchRequest object containing the generated fetch request.
 */
export function getRequest_create_fee(feeInput: FeeInput, waterfallItemInput: WaterfallItemInput): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.FEE,
        method: HttpMethods.POST,
        query_parameters: {},
        body: {
            waterfall_item: waterfallItemInput,
            fee: feeInput
        },
    }
}


/**
 * Creates a FetchRequest object populated with the parameters necessary for updating an existing
 * fee on the server.
 * @param fee An object of type Fee containing the updated fee data.
 * @returns A FetchRequest object containing the generated fetch request.
 */
export function getRequest_update_fee(fee: Fee): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.FEE,
        method: HttpMethods.PUT,
        query_parameters: {},
        body: fee,
    };
}


/**
 * Creates a FetchRequest object populated with the parameters necessary for triggering the query of fees
 * on the server.
 * @param transaction_id The UUID of the transaction to query for.
 * @returns A FetchRequest object containing the generated fetch request.*/
export function getRequest_get_all_fees(transaction_id:UUID): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.FEE,
        method: HttpMethods.GET,
        query_parameters: { transaction_id:transaction_id },
    }
}


/**
 * Creates a FetchRequest object populated with the parameters necessary for deleting an existing
 * fee on the server.
 * @param fee_id The UUID of the fee to delete.
 * @returns A FetchRequest object containing the generated fetch request.
 */
export function getRequest_delete_fee(fee_id: UUID): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.FEE,
        method: HttpMethods.DELETE,
        query_parameters: { fee_id: fee_id },
    };
}
